export default __webpack_public_path__ + "static/tech-stack-1a82d1a63773584df187b2d842cce6f6.png";